import { rei } from "@/services/api"
import moment from "moment"

class ProtocoloConfigService {
  static getConfig () {
    return rei.get('/protocolo-config').then(res => res.data)
  }

  static delete (id) {
    return rei.delete(`/protocolo-config/${ id }`).then(res => res.data)
  }

  static store (config) {
    const payload = {
      ano: config.ano,
      protocolo_atual: config.protocolo_atual
    }

    return rei.post(`/protocolo-config`, payload).then(res => res.data)
  }

  static update (id, config) {
    const payload = {
      ano: config.ano,
      protocolo_atual: config.protocolo_atual
    }

    return rei.put(`/protocolo-config/${ id }`, payload).then(res => res.data)
  }

  static getLastNumber () {
    const payload = {
      ano: moment().format('YYYY'),
    }

    return rei.post('protocolo-ultimo-numero', payload).then(res => res.data)
  }
}

export default ProtocoloConfigService
